import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomOut = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			width: 16,
			height: 16,
			x: 0,
			y: 0,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h16v16H0V0z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3840_154647)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#545F7E",
				fillRule: "evenodd",
				d: "M11.023 10.153l3.78 3.728a.65.65 0 01.004.924.657.657 0 01-.928.005l-3.798-3.747a5.633 5.633 0 01-3.436 1.165C3.533 12.228 1 9.71 1 6.614 1 3.52 3.532 1 6.645 1c3.113 0 5.646 2.52 5.645 5.614a5.567 5.567 0 01-1.267 3.54zM6.645 2.306c-2.392 0-4.331 1.93-4.331 4.308 0 2.38 1.94 4.308 4.33 4.308 2.393 0 4.332-1.93 4.332-4.308 0-2.379-1.94-4.308-4.331-4.308zM4.466 5.961h4.359c.363 0 .657.293.657.653 0 .36-.294.653-.657.653H4.466a.655.655 0 01-.656-.653c0-.36.294-.653.656-.653z",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3840_154647",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0H14V14H0z",
				transform: "translate(1 1)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgZoomOut);
export default ForwardRef;
